import {ChangeDetectorRef, Component, ViewChild, ViewEncapsulation,} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {Customer} from "../../../model/customer/customer";
import {TranslateService} from '@ngx-translate/core';
import {CustomerCustomerService} from "../../../services/customer/customer/customer-customer.service";
import {CrudBaseComponent} from "../../../crystal-elements/crud/crud-base.component";
import {CCRoles} from "../../../model/security/cc-roles-type";
import {CustomerCustomerTableConfigService} from "../../../services/customer/customer/customer-customer-table-config.service";
import {CustomerCustomerFormConfigService} from "../../../services/customer/customer/customer-customer-form-config.service";
import {CrudTableComponent} from "../../../crystal-elements/crud/crud-table.component";
import {CustomerCustomerDataLoadingService} from "../../../services/customer/customer/customer-customer-data-loading.service";
import {CommonFieldService} from "../../../services/common/common-field.service";
import {FieldsService} from "../../../services/common/fields-service";

@Component({
  selector: 'app-customer',
  templateUrl: './customer.component.html',
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
})
export class CustomerComponent extends CrudBaseComponent<Customer> {

  @ViewChild('crudTable')
  public crudTable: CrudTableComponent;

  batchUpdateDialogVisible: boolean = false;
  batchAction: "update" | "clone" = "update";

  constructor(cdref: ChangeDetectorRef,
              commonFieldService: CommonFieldService,
              customerCustomerService: CustomerCustomerService,
              messageService: MessageService,
              confirmationService: ConfirmationService,
              translateService: TranslateService,
              private readonly tableConfigService: CustomerCustomerTableConfigService,
              private readonly formConfigService: CustomerCustomerFormConfigService,
              private readonly fieldsService: FieldsService,
              protected dataLoadingService: CustomerCustomerDataLoadingService) {
    super(cdref, messageService, confirmationService, translateService, commonFieldService);
    this.crudService = customerCustomerService;
    this.newRecord = new Customer();
    this.newRecord.enabled = true;
    this.writeRoles = CCRoles.ROLES_CUSTOMER_WRITE;
    this.transPartKey = 'customer';
    this.fieldId = 'id';
  }

  protected initConfigs() {
    super.initConfigs();
    this.tableConfig = this.tableConfigService.loadConfig(this);
    this.formConfig = this.formConfigService.loadConfig(this)
    this.initButtons();
  }

  protected initButtons() {
    this.headerButtonConfig.splice(3, 0,
      {
        'tooltip': this.translateService.instant('page.' + this.transPartKey + '.table.batch_update_button'),
        'icon': 'fas fa-pen-to-square',
        class: ' p-button-help',
        command: records => this.batchUpdate(),
        enabled: () => !this.hasOneSelection() && this.hasMultipleSelection()
      },
      {
        'tooltip': this.translateService.instant('page.' + this.transPartKey + '.table.batch_clone_button'),
        'icon': 'fa-regular fa-clone cc-ico-clone-edit',
        class: ' p-button-help',
        command: records => this.batchClone(),
        enabled: () => !this.hasOneSelection() && this.hasMultipleSelection()
      },
    );
    this.headerButtonConfig = [...this.headerButtonConfig];

    this.contextMenuConfig.splice(2, 0,
      {
        id: 'batch-update',
        label: this.translateService.instant('page.' + this.transPartKey + '.table.batch_update_button'),
        icon: 'fas fa-pen-to-square',
        command: () => {
          this.batchUpdate();
        }
      },
      {
        id: 'batch-clone',
        label: this.translateService.instant('page.' + this.transPartKey + '.table.batch_clone_button'),
        icon: 'fa-regular fa-clone cc-ico-clone-edit',
        command: () => {
          this.batchClone();
        }
      }
    );
    this.contextMenuConfig = [...this.contextMenuConfig];
  }

  onFormShow() {
    this.commonFieldService.clearTraders();
    this.settingsFormLoadingProgressValue = 0;
    this.dataLoadingService.loadTraders(this);
    this.dataLoadingService.refreshBrokerageTables(this.formRecord);
  }

  protected initData(): void {
    super.initData();

    this.settingsFormLoadingProgressValue = 0;

    this.tracker = this.fieldsService.createTracker();

    this.tracker.progress.subscribe(value => {
      this.settingsFormLoadingProgressValue = value;
    });

    this.dataLoadingService.loadData(this);
  }

  public confirmDialog(
    action: () => void,
    titleKey: string,
    messageKey: string,
    submitKey = 'common.dialog.ok',
    cancelKey = 'common.dialog.cancel',
  ): void {
    this.confirmationService.confirm({
      header: this.getTranslation(titleKey),
      message:
        this.getTranslation(messageKey),
      icon: 'fas fa-exclamation-triangle',
      acceptLabel: this.getTranslation(submitKey),
      rejectLabel: this.getTranslation(cancelKey),
      acceptButtonStyleClass: 'p-button-danger p-button-sm',
      rejectButtonStyleClass: 'p-button-warning p-button-sm',
      accept: () => action(),
    });
  }

  private batchUpdate() {
    this.doBatchAction("update");
  }

  private batchClone() {
    this.doBatchAction("clone");
  }

  private doBatchAction(action: "update" | "clone") {
    if (this.selectedRecords && this.selectedRecords.length > 0) {
      this.formRecord = {...this.selectedRecords[0]};
    }
    this.onFormShow();

    this.batchUpdateDialogVisible = true;
    this.batchAction = action;
  }



  refreshContextMenu() {
    this.contextMenuConfig.forEach(menu => {
      if (menu.id === 'batch-update'||menu.id === 'batch-clone') {
        menu.disabled = this.hasOneSelection() || !this.hasMultipleSelection()
      }
    });
    this.contextMenuConfig = [...this.contextMenuConfig];
  }

  public onSaved() {
    this.loadRecords();
  }
}
